var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item.media
    ? _c("div", { staticClass: "thumbnail-editor" }, [
        _c("h3", [_vm._v("Select Thumbnail")]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "thumbs" },
          _vm._l(_vm.thumbs, function(thumb, ti) {
            return _c(
              "li",
              {
                class: { active: _vm.item.media.thumbnail == thumb },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.select(thumb)
                  }
                }
              },
              [_c("img", { attrs: { src: _vm.posterUrl(thumb) } })]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "activethumb" },
          [
            _c("thumbnail-crop", {
              ref: "thumbCrop",
              attrs: { src: _vm.posterUrl(), crop: _vm.currentCrop },
              on: {
                "update:crop": function($event) {
                  _vm.currentCrop = $event
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "uploader" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("input", {
            ref: "filechooser",
            attrs: { type: "file" },
            on: { change: _vm.uploadFile }
          })
        ]),
        _vm._v(" "),
        _vm.currentCrop
          ? _c(
              "div",
              {
                staticClass: "save-crop",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.saveCrop($event)
                  }
                }
              },
              [_vm._m(1)]
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("span")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("span")])
  }
]
render._withStripped = true

export { render, staticRenderFns }